// API Settings
export const SET_API_SETTINGS_URL = 'SET_API_SETTINGS_URL';
export const SET_API_SETTINGS_TOKEN = 'SET_API_SETTINGS_TOKEN';
export const RESET_API_SETTINGS = 'RESET_API_SETTINGS';

// Model (description)
export const SET_MODEL_DESCRIPTION = 'SET_MODEL_DESCRIPTION';
export const RESET_MODEL_DESCRIPTION = 'RESET_MODEL_DESCRIPTION';
export const UPDATE_FILTER_STRING = 'UPDATE_FILTER_STRING';
export const UPDATE_FILTER_PARAMETERS = 'UPDATE_FILTER_PARAMETERS';
export const UPDATE_FILTER_CONSTANTS = 'UPDATE_FILTER_CONSTANTS';
export const UPDATE_FILTER_INPUTS = 'UPDATE_FILTER_INPUTS';
export const UPDATE_FILTER_OUTPUTS = 'UPDATE_FILTER_OUTPUTS';
export const UPDATE_FILTER_CONTINUOUS = 'UPDATE_FILTER_CONTINUOUS';
export const UPDATE_FILTER_HIDDEN = 'UPDATE_FILTER_HIDDEN';

// Model (simulation)
export const SAVE_SIMULATION_RESULTS = 'SAVE_SIMULATION_RESULTS';
export const UPDATE_PLOT_FILTER_STRING = 'UPDATE_PLOT_FILTER_STRING';
export const RESET_SIMULATION_RESULTS = 'RESET_SIMULATION_RESULTS';

// Model (parameters)
export const UPDATE_PARAMETERS_FILTER_STRING = 'UPDATE_PARAMETERS_FILTER_STRING';
export const UPDATE_MODEL_PARAMETER = 'UPDATE_MODEL_PARAMETER';
export const REMOVE_MODEL_PARAMETER = 'REMOVE_MODEL_PARAMETER';
export const RESET_MODEL_PARAMETERS = 'RESET_MODEL_PARAMETERS';

// Model (input)
export const SET_INPUT_FILE = "SET_INPUT_FILE";
export const RESET_INPUT_FILE = "RESET_INPUT_FILE";

// Plot
export const SET_PLOT_VARIABLE = 'SET_PLOT_VARIABLE';
export const RESET_PLOT_RESULTS = 'RESET_PLOT_RESULTS';

// Loading spinner
export const SET_LOADING_MESSAGE = 'SET_LOADING_MESSAGE';
export const RESET_LOADING_MESSAGE = 'RESET_LOADING_MESSAGE';

// Error message
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';

// Home tab
export const SELECT_TAB = 'SELECT_TAB';
export const RESET_SELECTED_TAB = 'RESET_SELECTED_TAB';

// Dashboard
export const SET_DASHBOARD_DEFINITION = 'SET_DASHBOARD_DEFINITION';
export const RESET_DASHBOARD_DEFINITION = 'RESET_DASHBOARD_DEFINITION';

// Config
export const SET_CONFIG_DEFINITION = "SET_CONFIG_DEFINITION";
export const RESET_CONFIG_DEFINITION = "RESET_CONFIG_DEFINITION";

// Readme
export const SET_README = "SET_README";
export const RESET_README = "RESET_README";


// WEBPACK FOOTER //
// ./src/app/actions/action-types.js